import { render, staticRenderFns } from "./userProfile.vue?vue&type=template&id=3d07fdc8&"
import script from "./userProfile.vue?vue&type=script&lang=js&"
export * from "./userProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports